import { Stack, Tabs, TabList, Tab, TabPanels, TabPanel } from "@carbon/react";
import { CardComponent, CardRow } from "../../../components/Layouts/Card.styles";
import { HeatMap, Dashboard } from "@carbon/icons-react";
import Typography from "../../../components/Basics/Typography";
import Card from '../../../components/Layouts/Card';
import { Iframe } from "../../../components/Basics/Iframe.styles";


const Acopios = () => {
  return (
    <Stack gap={3}>
      <CardComponent width="100%">
        <Card justifyContent='flex-start' >
          <Dashboard size={18} />
          <Typography className='cds--type-heading-compact-01'>
            MONITOREO DE ACOPIOS
          </Typography>
        </Card>
        <CardRow width='inherit'>
          <Card width='100%' padding="0" flexDirection='column'>
            <Iframe title="Monitoring map" src="https://grafana.terrestra.tech/d/ccc32768-c933-41f9-b570-3822fb259a5d/acopios-tiempo-real?orgId=1&from=1763414115352&to=1763500515352&kiosk" width="100%" height="100%" />
          </Card>
        </CardRow>
      </CardComponent>
    </Stack>
  )
}

export default Acopios